import VideoYoutubeIframe from './VideoYoutubeIframe';

export default VideoYoutubeIframe;
